import { parse as parseYaml } from "yaml";

/** Per-brain cost-report config, read from `.m8t/brain.yaml` `processes.costReport`.
 *  Read-only, defensive: any malformed/absent block ⇒ disabled. */
export interface CostReportConfig {
  enabled: boolean;
  cadenceDays: number;
  model?: string;
}

export const DEFAULT_COST_REPORT_CADENCE_DAYS = 14;

export function parseCostReportConfig(rawYaml: string, env: NodeJS.ProcessEnv): CostReportConfig {
  let parsed: unknown;
  try {
    parsed = parseYaml(rawYaml);
  } catch {
    return { enabled: false, cadenceDays: DEFAULT_COST_REPORT_CADENCE_DAYS };
  }
  const block =
    parsed && typeof parsed === "object"
      ? ((parsed as { processes?: { costReport?: Record<string, unknown> } }).processes?.costReport ?? {})
      : {};
  const cadence = typeof block.cadenceDays === "number" && block.cadenceDays > 0
    ? block.cadenceDays
    : DEFAULT_COST_REPORT_CADENCE_DAYS;
  const model = typeof block.model === "string" ? block.model : undefined;
  const envModel = env.M8T_COST_REPORT_MODEL;
  return {
    enabled: block.enabled === true,
    cadenceDays: cadence,
    ...(envModel ?? model ? { model: envModel ?? model } : {}),
  };
}
